/**
 * Route for `campaign-wise-invoice-grouping`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignWiseInvoiceGroupingPage } from "../features/campaign-wise-invoice-grouping/CampaignWiseInvoiceGroupingPage";

export const campaignWiseInvoiceGroupingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-wise-invoice-grouping",
	component: CampaignWiseInvoiceGroupingPage,
});

export default campaignWiseInvoiceGroupingRoute;
